import { Switch, Route, Redirect } from "react-router-dom";

import { useScrollToTop } from "app/hooks/general";
import { ROUTES } from "app/constants/app";
import AboutSection from "app/sections/about/About";
import ChangelogSection from "app/sections/about/Changelog";
import PlansSection from "app/sections/about/JoinAsCompany";
import HomeSection from "app/sections/Home";
import Navigation from "app/sections/Navigation";
import Footer from "app/sections/Footer";
import CompanyCategory from "app/sections/CompanyCategory";
import Company from "app/sections/Company";
import ProductCategory from "app/sections/ProductCategory";
import Product from "app/sections/Product";
import { useBackgroundLocation } from "app/hooks/routes";
import ShopperSignIn from "app/sections/shopper/ShopperSignIn";
import ShopperSignUp from "app/sections/shopper/ShopperSignUp";
import ShopperBrowser from "app/sections/shopper/ShopperBrowser";
import useRUM from "app/hooks/rum";

export default function Routes() {
  const { location, locationBackground } = useBackgroundLocation();

  useScrollToTop();

  useRUM();

  return (
    <>
      <Navigation />

      <Switch location={locationBackground || location}>
        <Route exact path={ROUTES.home} component={HomeSection} />

        <Route
          path={`${ROUTES.companyCategory}/:_id`}
          component={CompanyCategory}
        />

        <Route path={`${ROUTES.company}/:_id`} component={Company} />

        <Route
          path={`${ROUTES.productCategory}/:_id`}
          component={ProductCategory}
        />

        <Route path={`${ROUTES.product}/:_id`} component={Product} />

        <Route exact path="/about" component={AboutSection} />

        <Route exact path="/join" component={PlansSection} />

        <Route exact path="/changelog" component={ChangelogSection} />

        <Redirect to={ROUTES.home} />
      </Switch>

      <Switch>
        <Route exact path={ROUTES.shopperBrowser} component={ShopperBrowser} />
        <Route exact path={ROUTES.shopperSignIn} component={ShopperSignIn} />
        <Route exact path={ROUTES.shopperSignUp} component={ShopperSignUp} />
      </Switch>

      <Footer />
    </>
  );
}
